var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "FormBox",
        { attrs: { title: "证件上传", width: 600 } },
        [
          _c(
            "el-row",
            { staticStyle: { width: "100%" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("ImageUpload", {
                    staticClass: "image-upload",
                    staticStyle: { height: "200px" },
                    attrs: { imgType: "FRONT", label: "负责人身份证正面" },
                    model: {
                      value: _vm.legalIdCardFront,
                      callback: function($$v) {
                        _vm.legalIdCardFront = $$v
                      },
                      expression: "legalIdCardFront"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("ImageUpload", {
                    staticClass: "image-upload",
                    staticStyle: { height: "200px" },
                    attrs: { imgType: "BACK", label: "负责人身份证背面" },
                    model: {
                      value: _vm.legalIdCardBack,
                      callback: function($$v) {
                        _vm.legalIdCardBack = $$v
                      },
                      expression: "legalIdCardBack"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticStyle: { width: "100%", "margin-top": "20px" },
              attrs: { gutter: 20 }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("ImageUpload", {
                    staticClass: "image-upload",
                    staticStyle: { height: "300px" },
                    attrs: { imgType: "LICENSE", label: "公证机构执业证" },
                    model: {
                      value: _vm.organizationRegImg,
                      callback: function($$v) {
                        _vm.organizationRegImg = $$v
                      },
                      expression: "organizationRegImg"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "login-btn",
              attrs: { loading: _vm.loading, type: "primary" },
              on: { click: _vm.submit }
            },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }